import { B2bHeader } from './B2bHeader';
import { B2cHeader } from './B2cHeader';
import { isB2bDomain } from 'helpers/isDomainLocale';
import { useDomainConfig } from 'hooks/useDomainConfig';

export type HeaderProps = {
    simple?: boolean;
};

export const HEADER_TEST_IDENTIFIER = 'layout-header';

export const Header: FC<HeaderProps> = ({ simple }) => {
    const domainConfig = useDomainConfig();

    return isB2bDomain(domainConfig) ? <B2bHeader simple={simple} /> : <B2cHeader simple={simple} />;
};
